// src/api/brouillonsFnct.api.ts — SCE Issues
// Brouillons de FNC-T (« Garder en brouillon », étape 5 du 14/10) : bloc
// `brouillonsFnct` du JSON `Prefs` de SA ligne de SCE_UserPrefs, plus une copie
// locale. Règles : utils/brouillonFnct. Le bloc est relu avant d'être réécrit
// (ecrireBlocPrefs ne touche à rien d'autre de la ligne).

import { ecrireBlocPrefs, lireBlocPrefs } from './userPrefs.api'
import {
  CLE_BLOC_BROUILLONS_FNCT,
  avecBrouillon,
  effacerBrouillonLocal,
  ecrireBrouillonLocal,
  lireBrouillonLocal,
  lireBrouillons,
  plusRecent,
  sansBrouillon,
  type BrouillonFnct,
} from '@/utils/brouillonFnct'

/** Le brouillon d'un problème : le plus récent de la copie locale et du bloc SharePoint. */
export async function chargerBrouillonFnct(upn: string, issueId: string): Promise<BrouillonFnct | null> {
  const local = lireBrouillonLocal(issueId)
  try {
    const distant = lireBrouillons(await lireBlocPrefs(upn, CLE_BLOC_BROUILLONS_FNCT), new Date())[issueId] ?? null
    return plusRecent(local, distant)
  } catch {
    // SharePoint injoignable : la copie locale suffit.
    return local
  }
}

/** Garde le brouillon (copie locale tout de suite, puis SharePoint). */
export async function garderBrouillonFnct(upn: string, issueId: string, b: BrouillonFnct): Promise<void> {
  ecrireBrouillonLocal(issueId, b)
  const bloc = await lireBlocPrefs(upn, CLE_BLOC_BROUILLONS_FNCT)
  await ecrireBlocPrefs(upn, CLE_BLOC_BROUILLONS_FNCT, avecBrouillon(bloc, issueId, b, new Date()))
}

/** Oublie le brouillon (FNC-T ouverte, ou abandon) ; un échec SharePoint n'empêche rien. */
export async function effacerBrouillonFnct(upn: string, issueId: string): Promise<void> {
  effacerBrouillonLocal(issueId)
  try {
    const bloc = await lireBlocPrefs(upn, CLE_BLOC_BROUILLONS_FNCT)
    if (lireBrouillons(bloc, new Date())[issueId]) {
      await ecrireBlocPrefs(upn, CLE_BLOC_BROUILLONS_FNCT, sansBrouillon(bloc, issueId, new Date()))
    }
  } catch (err) {
    console.warn('[brouillonsFnct] brouillon non effacé de SharePoint :', err)
  }
}
